import get from "lodash/get";
import React from "react";
import pretty from "Shared/pretty";
import { FilterOptionsGroup } from "../FilterOptionsGroup/FilterOptionsGroup";
import { UserFilterCategory } from "../UserFilterCategory/UserFilterCategory";
import { DailypayFilterState } from "../UserFiltersMenu";

export interface DailypayFilterProps {
  filter: DailypayFilterState;
  onFilterChange: (key: string, selected: boolean) => void;
}

export const DailypayFilter = (props: DailypayFilterProps) => {
  const { filter, onFilterChange } = props;

  return (
    <UserFilterCategory title="DailyPay Status">
      <FilterOptionsGroup
        options={Object.keys(filter).map((key: string) => {
          return {
            key,
            label: pretty.startCase(key),
            selected: get(filter, key),
          };
        })}
        onChange={onFilterChange}
      />
    </UserFilterCategory>
  );
};
